var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('field-work-flows',{attrs:{"entity":_vm.taskEvent},on:{"update:entity":function($event){_vm.taskEvent=$event}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }